import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M16.0289 1.96821C15.7352 1.67612 15.2603 1.67744 14.9682 1.97114L10.0137 6.95308L6.53033 3.46967C6.23744 3.17678 5.76256 3.17678 5.46967 3.46967C5.17678 3.76256 5.17678 4.23744 5.46967 4.53033L8.23914 7.2998H4.75C3.23122 7.2998 2 8.53102 2 10.0498V18.5498C2 20.0686 3.23122 21.2998 4.75 21.2998H19.25C20.7688 21.2998 22 20.0686 22 18.5498V10.0498C22 8.53102 20.7688 7.2998 19.25 7.2998H11.7844L16.0318 3.02886C16.3239 2.73516 16.3226 2.26029 16.0289 1.96821ZM4.75 8.7998C4.05964 8.7998 3.5 9.35945 3.5 10.0498V18.5498C3.5 19.2402 4.05964 19.7998 4.75 19.7998H19.25C19.9404 19.7998 20.5 19.2402 20.5 18.5498V10.0498C20.5 9.35945 19.9404 8.7998 19.25 8.7998H4.75ZM6.75 11.7998C6.61193 11.7998 6.5 11.9117 6.5 12.0498V16.5498C6.5 16.6879 6.61193 16.7998 6.75 16.7998H14.25C14.3881 16.7998 14.5 16.6879 14.5 16.5498V12.0498C14.5 11.9117 14.3881 11.7998 14.25 11.7998H6.75ZM5 12.0498C5 11.0833 5.7835 10.2998 6.75 10.2998H14.25C15.2165 10.2998 16 11.0833 16 12.0498V16.5498C16 17.5163 15.2165 18.2998 14.25 18.2998H6.75C5.7835 18.2998 5 17.5163 5 16.5498V12.0498ZM18.75 15.2998C18.75 14.8856 18.4142 14.5498 18 14.5498C17.5858 14.5498 17.25 14.8856 17.25 15.2998V17.2998C17.25 17.714 17.5858 18.0498 18 18.0498C18.4142 18.0498 18.75 17.714 18.75 17.2998V15.2998Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const TiviOutlined = React.forwardRef(IconComponent);
TiviOutlined.displayName = 'TiviOutlined';

export { TiviOutlined };
